<template>
  <div class="product-item" @click="handleClick" >
    <div class="product-item__name">
      Ref: {{ bonDeLivraison.ref }}
    </div>
    <div class="product-item__title">
      {{ $t(`bonDeLivraisonStatus.${bonDeLivraison.status}`) }}
    </div>
  </div>
</template>
<script>
import BonDeLivraison from '@/entities/BonDeLivraison';

export default {
  components: {},
  props: {
    bonDeLivraison: { type: BonDeLivraison },
  },
  methods: {
    handleClick() {
      this.$emit('onClick');
    },
  },
};
</script>
<style lang="stylus" scoped>
.product-item {
  background: white;
  border-radius: 3px;
  border: solid 1px whitesmoke;
  width: 100%;
  padding: 20px 10px;
  &:hover {
    background-color: #dcdcdc33;
    cursor: pointer;
  }
  &:hover .choose-user-label {
    opacity: 1;
  }
}

.choose-user-label {
  opacity:0;
  color: #969696;
}

.product-item__name, .product-item__title {
  text-align: left;
}

.product-item__name {
  color: #2f2f2f;
}
.product-item__title {
  color: #8e8e8e;
}

.quantity-button-wrap {
  float: right;
  margin-top: 10px;
}
</style>
